import Clarity from '@microsoft/clarity'

const PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined

export function initClarity(): void {
    if (!PROJECT_ID) return
    Clarity.init(PROJECT_ID)
}
